import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--grey-200);
  width: 14px;
  max-width: 14px;
  height: 100%;
  flex: 1;
  border: none;
  padding: 0;
  border-radius: 0;
  transition: all 0.2s;

  img {
    width: 5px;
  }

  &:hover {
    background-color: var(--grey-300);
  }
`;
